import { getListOfActiveCities } from '@/api/saudiArabia';

export const $httpApi = {
  getListOfActiveCities
};
